<form [formGroup]="contractForm" (ngSubmit)="onSubmit()">
  <mat-card class="mat-card-contract-detail mat-card-contract-detail-info">
    <mat-card-header>
      <mat-card-title>{{ 'customer.general-informations' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content-contract-detail">
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('site')">*</span>{{ 'label.site' | translate}}</label>
        <app-site-list [control]="$any(contractForm).controls['site']" class="content-row-input" [pacoOnly]="true">
        </app-site-list>
      </div>
      <!-- <div class="content-row">
      </div> -->
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('dateBegin')">*</span>{{ 'label.beginDate' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="startDateContract" formControlName="dateBegin" autocomplete="off"
            [max]="contractForm.get('dateEnd')?.value">
          <mat-datepicker-toggle matSuffix [for]="startDateContract"></mat-datepicker-toggle>
          <mat-datepicker #startDateContract [disabled]="contractForm.get('dateBegin')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('dateEnd')">*</span>{{ 'label.endDate' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="endDateContract" formControlName="dateEnd" autocomplete="off"
            [min]="contractForm.get('dateBegin')?.value">
          <mat-datepicker-toggle matSuffix [for]="endDateContract"></mat-datepicker-toggle>
          <mat-datepicker #endDateContract [disabled]="contractForm.get('dateEnd')?.disabled"></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('dateStartBilling')">*</span>{{ 'label.dateStartBilling' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput [matDatepicker]="dateStartBillingContract" formControlName="dateStartBilling"
            autocomplete="off" [min]="contractForm.get('dateBegin')?.value" [max]="contractForm.get('dateEnd')?.value">
          <mat-datepicker-toggle matSuffix [for]="dateStartBillingContract"></mat-datepicker-toggle>
          <mat-datepicker #dateStartBillingContract [disabled]="contractForm.get('dateStartBilling')?.disabled">
          </mat-datepicker>
        </mat-form-field>
      </div>

      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('quantityMin')">*</span>{{ 'label.min-tonnage-annual' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="quantityMin" type="number" autocomplete="off" step="0.001">
          <span matSuffix>{{ 'label.tonne(s)' | translate}}</span>
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('sliceDegressiveness')">*</span>{{ 'label.decreasing-by-slice-of' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="sliceDegressiveness" type="number" autocomplete="off">
          <span matSuffix>{{ 'label.tonne(s)' | translate}}</span>
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.multiplier' | translate}} 2021</label>
        <div class="content-row-input" style="display: flex; justify-content: flex-end;">
          <div style="display: flex; flex-direction: row; align-items: center;">
            <label>{{currentCoef | number :'0.4' :'fr'}}</label>
            <mat-icon
              [matTooltip]="currentIndex?.value + ' (index année courrante) / ' + masterIndex?.value + ' (index 2000)'"
              style="margin-left: 10px;cursor: help;" color="primary">info</mat-icon>
          </div>
        </div>
      </div>

      <div class="content-row" *ngIf="(contractDetail?.id || contractDetail?.contract?.id)">
        <label class="content-row-label">{{ 'label.type' | translate}}</label>
        <span class="content-row-input">
          {{ 'contract.' + contractDetail?.contract?.contractType?.name | translate}}
        </span>
      </div>
     
      <div class="content-row"
        *ngIf="(contractDetail?.id || contractDetail?.contract?.id) && (contractDetail?.contract?.contractTypeEnum == ContractType.publicDock)">
        <label class="content-row-label">{{ 'contract.handling' | translate}}</label>
        <span class="content-row-input">
          {{ (contractDetail?.contract?.isPunctualHandling) ? ('contract.handling-punctual' | translate ) :
          ('contract.handling-permanent' | translate ) }}
        </span>
      </div>

      <!-- <div class="content-row">
      </div> -->
    </mat-card-content>
  </mat-card>

  <mat-card class="mat-card-contract-detail mat-card-contract-detail-info">
    <mat-card-header>
      <mat-card-title>{{ 'customer.billing-informations' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content-contract-detail">

      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('billingName')">*</span>{{ 'label.billing-name' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="billingName" type="text" autocomplete="off">
        </mat-form-field>
      </div>
      <div class="content-row">
        <label class="content-row-label">
        <span class="required-asterisk" *ngIf="isRequiredField('billingEmail')">*</span>{{ 'label.mail' | translate}}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="billingEmail" type="text" autocomplete="off">
        </mat-form-field>
      </div>

      <div formGroupName="billingAddress" class="mat-card-content-contract-detail" style="width: 100%;">
        <div class="content-row">
          <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('billingAddress.address1')">*</span>{{ 'label.address' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="address1" type="text" autocomplete="off">
          </mat-form-field>
        </div>

        <div class="content-row">
          <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('billingAddress.zip')">*</span>{{ 'label.zip' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="zip" type="number" autocomplete="off">
          </mat-form-field>
        </div>

        <div class="content-row">
          <label class="content-row-label">
          <span class="required-asterisk" *ngIf="isRequiredField('billingAddress.city')">*</span>{{ 'label.city' | translate}}</label>
          <mat-form-field class="content-row-input">
            <input matInput formControlName="city" type="text" autocomplete="off">
          </mat-form-field>
        </div>
      </div>

      <div class="comment-row">
        <mat-form-field style="width: 100%;">
          <textarea rows="5" formControlName="comment" matInput style="width: 100%;"
            placeholder="{{ 'label.comment' | translate}}"></textarea>
        </mat-form-field>
      </div>

    </mat-card-content>
    <mat-card-actions class="customer-card-action" *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
      <button mat-raised-button color="warn" type="button" (click)="onDelete()"
        *ngIf="(contractDetail?.id || contractDetail?.contract?.id ) && contractDetail?.isReadOnlyMode">
        <mat-icon>delete</mat-icon> {{ 'button.delete' | translate }}
      </button>
      <button mat-raised-button color="primary" type="button" (click)="onEdit()"
        *ngIf="(contractDetail?.id || contractDetail?.contract?.id ) && contractDetail?.isReadOnlyMode">
        <mat-icon>edit</mat-icon> {{ 'button.edit' | translate }}
      </button>
      <button mat-raised-button color="warn" type="button" (click)="onCancel()"
        *ngIf="(contractDetail?.id || contractDetail?.contract?.id ) && contractDetail?.isEditMode">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="contractForm.invalid && (companyDetail != null)"
        *ngIf="(contractDetail?.isEditMode || contractDetail?.isCreationMode) && (contractDetail?.id || contractDetail?.contract?.id )">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</form>

<mat-card class="mat-card-contract-detail mat-card-contract-detail-info">
  <mat-tab-group>
    <mat-tab>
      <ng-template mat-tab-label>
        <span>{{ 'label.price' | translate}}</span>
      </ng-template>
      <div class="contract-slice-action" *ngIf="((contractDetail?.contract?.contractTypeEnum == ContractType.termConcession) || (contractDetail?.contract?.contractTypeEnum == ContractType.publicDock && !contractDetail?.contract?.isPunctualHandling))
        && uiService.visibleByRole([Role.manager, Role.administrator])">
        <button mat-raised-button color="primary" (click)="onCreateSlice()">
          <mat-icon>add</mat-icon>
          {{ 'button.add-slice' | translate}}
        </button>
      </div>
      <div style="padding: 5px;">
        <table mat-table [dataSource]="dataSourceContractSlices" class="mat-elevation-z2" style="width: 100%;">
          <!-- index Column -->
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.slice-number' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.index}} </td>
          </ng-container>

          <!-- price Column -->
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.price' | translate}} (€)</th>
            <td mat-cell *matCellDef="let element"> {{element.price | number :'0.6' :'fr'}} </td>
          </ng-container>

          <!-- priceIndex Column -->
          <ng-container matColumnDef="priceIndex">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.price-index' | translate}} (€)</th>
            <td mat-cell *matCellDef="let element"> {{ element.priceIndex | number :'0.6' :'fr'}}</td>
          </ng-container>

          <!-- tonnage Column -->
          <ng-container matColumnDef="tonnage">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.tonnage' | translate}} (Tonne(s)) </th>
            <td mat-cell *matCellDef="let element">
              <span
                *ngIf="(contractDetail?.contract?.contractTypeEnum == ContractType.termConcession) || (contractDetail?.contract?.contractTypeEnum == ContractType.publicDock && !contractDetail?.contract?.isPunctualHandling)">
                {{element?.isLastSlice ? '< ' : ''}} {{element.tonnage | number : '0.3' :'fr'}} </span>
                  <span
                    *ngIf="(contractDetail?.contract?.contractTypeEnum == ContractType.precariousConcession) || (contractDetail?.contract?.contractTypeEnum == ContractType.publicDock && contractDetail?.contract?.isPunctualHandling)">
                    A la tonne
                  </span>
            </td>
          </ng-container>

          <!-- action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
              <button mat-raised-button color="primary" type="button" (click)="onEditSlice(element)"
                *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
                <mat-icon>edit</mat-icon> {{ 'button.edit' | translate }}
              </button>
              <button mat-raised-button color="warn" type="button" (click)="onDeleteSlice(element)"
                *ngIf="uiService.visibleByRole([Role.manager, Role.administrator]) && !element.isLastSlice">
                <mat-icon>delete</mat-icon> {{ 'button.delete' | translate }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsSlice"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsSlice;"></tr>
        </table>
      </div>
    </mat-tab>
    <mat-tab
      *ngIf="(contractDetail?.id || contractDetail?.contract?.id) && (contractDetail?.contract?.contractTypeEnum != ContractType.publicDock)">
      <ng-template mat-tab-label>
        <span>{{ 'customer.concessions' | translate}}</span>
      </ng-template>
      <div class="contract-slice-action"
        *ngIf="(contractDetail?.id || contractDetail?.contract?.id) && uiService.visibleByRole([Role.manager, Role.administrator])">
        <button mat-raised-button color="primary" (click)="onCreateConcessions()">
          <mat-icon>add</mat-icon>
          {{ 'button.add-concession' | translate}}
        </button>
      </div>
      <div style="padding: 5px;" s>
        <table mat-table [dataSource]="dataSourceContractConcessions" class="mat-elevation-z2" style="width: 100%;">
          <!-- area Column -->
          <ng-container matColumnDef="area">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.area' | translate}} (m²)</th>
            <td mat-cell *matCellDef="let element"> {{element.area | number :'0.0' :'fr'}}</td>
          </ng-container>

          <!-- price Column -->
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.price' | translate}} (€)</th>
            <td mat-cell *matCellDef="let element"> {{element.price | number :'0.6' :'fr'}}</td>
          </ng-container>

          <!-- priceIndex Column -->
          <ng-container matColumnDef="priceIndex">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.price-index' | translate}} (€)</th>
            <td mat-cell *matCellDef="let element"> {{ element.priceIndex | number :'0.6' :'fr'}}</td>
          </ng-container>

          <!-- percentageDiscount Column -->
          <ng-container matColumnDef="percentageDiscount">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.discount-percentage' | translate}} (%)</th>
            <td mat-cell *matCellDef="let element"> {{element.percentageDiscount | number :'0.2' :'fr'}}</td>
          </ng-container>

          <!-- startDate Column -->
          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef> {{ 'label.beginDate' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.startDate | date : 'dd/MM/yyyy'}}</td>
          </ng-container>

          <!-- zone Column -->
          <ng-container matColumnDef="zone">
            <th mat-header-cell *matHeaderCellDef> {{ 'contract.zone-type' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.zone}}</td>
          </ng-container>

          <!-- isFittedOutArea Column -->
          <ng-container matColumnDef="isFittedOutArea">
            <th mat-header-cell *matHeaderCellDef> {{ 'contract.fittedOutArea' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{ element.isFittedOutArea != null ? (element.isFittedOutArea |
              booleanToString) : ''}}</td>
          </ng-container>

          <!-- isGoodAccessibility Column -->
          <ng-container matColumnDef="isGoodAccessibility">
            <th mat-header-cell *matHeaderCellDef> {{ 'contract.accessibility-good' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.isGoodAccessibility != null ? (element.isGoodAccessibility
              | booleanToString) : ''}}</td>
          </ng-container>

          <!-- action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
              <button mat-mini-fab color="primary" type="button" (click)="onEditConcession(element)"
                *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-mini-fab color="warn" type="button" (click)="onDeleteConcession(element)"
                *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsConcession"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsConcession;"></tr>
        </table>
      </div>
    </mat-tab>
  </mat-tab-group>

</mat-card>